export default "__VITE_ASSET__28097a43__"